import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "@/components/Sidebar";
import BottomNav from "@/components/BottomNav";
import PendingOrdersNotification from "@/components/PendingOrdersNotification";
import { setNavigate } from "@/services/socket";

/**
 * Layout component for authenticated/private pages
 * Includes Sidebar and BottomNav navigation
 * Pages should only render their main content (without Sidebar/BottomNav/container-rtl wrapper)
 */
export default function PrivateLayout({ children }) {
  const navigate = useNavigate();

  // Register navigate function for socket reconnection route reloading
  useEffect(() => {
    setNavigate(navigate);
  }, [navigate]);

  return (
    <div className="container-rtl">
      <Sidebar />
      {children}
      <BottomNav />
      <PendingOrdersNotification />
    </div>
  );
}

